// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M7.99479 10.6654V7.9987M7.99479 5.33203H8.00146M14.6615 7.9987C14.6615 11.6806 11.6767 14.6654 7.99479 14.6654C4.31289 14.6654 1.32812 11.6806 1.32812 7.9987C1.32812 4.3168 4.31289 1.33203 7.99479 1.33203C11.6767 1.33203 14.6615 4.3168 14.6615 7.9987Z"
    />
  </svg>
);
const IconInfoCircle = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconInfoCircle;
